module.exports = __webpack_public_path__ + "img/footer-pattern-complete.e1e43f2203891de008737924a14a2749.svg";